// Func = limiting Scope for this file
var lastScrollTop = 0;

//booking dates
// var start = document.getElementById('arriveInput').value;
// var end = document.getElementById('departureInput').value;

let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
var opened = 0 ;



(function(){

	$(document).ready(function () {


		// Main Nav Dropdown 
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});


		$('p').each(function() {
			var $this = $(this);
			if($this.html().replace(/\s| /g, '').length == 0){
			  $this.remove();
			}
		});




		$( ".booking__close" ).click(function() {

			if ($(".booking__container").hasClass("open-booking-container")) {
				$(".booking__container").removeClass("open-booking-container");
				$(".booking__container").addClass("close-booking-container");
			}
			else{
				$(".booking__container").addClass("open-booking-container");
				$(".booking__container").removeClass("close-booking-container");

			}
			if ($("#header").hasClass("open-booking")) {
				$("#header").removeClass("open-booking");
				$("#header").addClass("close-booking");
			}
			else{
				$("#header").addClass("open-booking");
				$("#header").removeClass("close-booking");

			}
			
			
		});

		$("option").each(function() {

			var $this = $(this);
			$this.text($this.text().toUpperCase());
		});

		if(document.getElementById('booking-form')){
			document.getElementById('booking-form').bookingID.onchange = function() {
				var newaction = this.value;
				$(this).addClass("open");
				document.getElementById('hotel').value = newaction;
			};
		}
		

		function openMenu(menuBtn, menu){
			if( !menu.classList.contains('opened')) {
				menuBtn.classList.add("open");
				menu.style.display = 'block';
				menu.classList.add('open');
				menu.classList.add('opened');
				setTimeout(function() {
					menu.style.opacity = 1;
				}, 50);
			} else {
				if(window.innerWidth > 767 ) {
					menuBtn.classList.remove("open");
					menu.style.display = 'none';
					menu.classList.remove('opened');
				}
			}
		}

		var menuBtn = document.getElementById('menu-btn-location');
		var menu = document.getElementById('menu-location');
		if (isMobile) {
		var closeB = document.getElementById('close-menu-location');
		}

		if( menuBtn ) {
			menuBtn.addEventListener('click', () => {
				openMenu(menuBtn, menu);
			});
		}

		if( closeB ) {
			closeB.addEventListener('click', function() {
					console.log( menu.style.display );
					menu.style.display = 'none';
					menuBtn.classList.remove('open')
					menu.classList.remove('opened');
					menu.style.opacity = 0;
			});
		}

		let book_spa_btn = document.querySelector('#menu-btn-spa .btn-blue');
		let book_spa_menu = document.querySelector('#menu-book-spa');
		book_spa_btn.addEventListener('click', (e) => {
			book_spa_menu.classList.toggle('open');
			book_spa_btn.classList.toggle('open');
		})

		// let book_locations_btn = document.querySelector('#menu-btn-location');
		// let book_location_menu = document.querySelector('#menu-location');
		// // console.log( book_spa_btn );
		// book_locations_btn.addEventListener('click', (e) => {
		// 	book_location_menu.classList.toggle('open');
		// 	book_locations_btn.classList.toggle('open');
		// })



		$( "#booking-trigger" ).click(function() {
	
			if ($(".booking__container").hasClass("open-booking-container")) {
				$(".booking__container").removeClass("open-booking-container");
				$(".booking__container").addClass("close-booking-container");
			}
			else{
				$(".booking__container").addClass("open-booking-container");
				$(".booking__container").removeClass("close-booking-container");

			}
			if($("#booking-trigger").hasClass("open")){
				$("#booking-trigger").removeClass("open");
				$(".header-booking__list").removeClass("open");
			}
			else{
				$("#booking-trigger").addClass("open")
				$(".header-booking__list").addClass("open")
			}
			if ($("#header").hasClass("open-booking")) {
				$("#header").removeClass("open-booking");
				$("#header").addClass("close-booking");
			}
			else{
				$("#header").addClass("open-booking");
				$("#header").removeClass("close-booking");

			}
			
			
		});

		const btnContainer = document.querySelector('.btn-container');
		const bookingTrigger = document.querySelector('#booking-trigger');

		if(btnContainer && bookingTrigger){
			bookingTrigger.addEventListener('mouseover', () => {
				btnContainer.classList.add('hover');
			});
			bookingTrigger.addEventListener('mouseout', () => {
				btnContainer.classList.remove('hover');
			});
		}



		  //Open Navigation
		  $('#booking-btn').click(function(event) {
			$('html').addClass('hide-overflow');
			$('.nav-booking').addClass('open');
			$('.nav-booking').stop().animate({left:'0px'},{duration:300});
			if($('.nav-booking ul li a').hasClass('.item-open')){
				$(".item-open").get(0).scrollIntoView(false);
			}
		});

		$('.close-menu').click(function(event) {
			event.preventDefault();
			$('html').removeClass('hide-overflow');
			$('.nav-booking').removeClass('open');
			$('.nav-booking').stop().animate({left:'-100%'},{queue:false,duration:300});
		});


			// const btnElements = document.querySelectorAll('a.btn');
			// btnElements.forEach(btnElement => {
			// 	const textNode = btnElement.firstChild;
			// 	const spanElement = document.createElement('span');
			// 	btnElement.insertBefore(spanElement, textNode.nextSibling);
			// });
	
			// const btnElements2 = document.querySelectorAll('a.btn-alternative');
			// btnElements2.forEach(btnElement2 => {
			// 	const textNode2 = btnElement2.firstChild;
			// 	const spanElement2 = document.createElement('span');
			// 	btnElement2.insertBefore(spanElement2, textNode2.nextSibling);
			// });
	

			

		   //Open Navigation
		   $('#menu-btn').click(function(event) {
				$('html').addClass('hide-overflow');
				$('.nav-desktop').addClass('open');
			
				if($('.nav-desktop ul li a').hasClass('.item-open')){
					$(".item-open").get(0).scrollIntoView(false);
				}
			});

			$('.close-menu').click(function(event) {
				event.preventDefault();
				$('html').removeClass('hide-overflow');
				$('.nav-desktop').removeClass('open');
			
			});

			
			//Open Spa Nav
			$('#book-spa').click(function(event) {
				console.log('holss');
				$('html').addClass('hide-overflow');
				$('#book-spa-nav').addClass('open');
			});

			$('.close-book').click(function(event) {
				event.preventDefault();
				$('html').removeClass('hide-overflow');
				$('#book-spa-nav').removeClass('open');
			
			});



		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate("yy-mm-dd",$('#CheckIn').val());		
			let d2=$.datepicker.parseDate("yy-mm-dd",$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: "yy-mm-dd",
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: "yy-mm-dd",
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};


		 /**
     * Check in and check out datepicker for booking engine
     ******************************************/
    var after_first_date_selection = false;

	$( "#CheckIn" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
        dateFormat: "yy M d",
        altField: "#CheckIn--alt",
        altFormat: "yy-mm-dd",
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function( selectedDate ) {
			var getDate = $(this).datepicker('getDate');
        	var newDate = new Date(getDate.getTime());
        	newDate.setDate(newDate.getDate() + 1);
			$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			if(after_first_date_selection){
			    console.log("selection!");
                $( "#CheckOut" ).datepicker( "setDate", newDate );
            }
        }
	});
	$( "#CheckOut" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
        dateFormat: "yy M d",
        altField: "#CheckOut--alt",
		altFormat: "yy-mm-dd",
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function( selectedDate ) {
			// $( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
            return after_first_date_selection = true;
		}
	});


    //booking datepicker for [ header booking ]
		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		setUpBooking();
   
        $('#altDates').on('change', function(){
            let dates = $(this).val().split('/');
			
            $('#arriveInput').attr('value',dates[0]);
            $('#departureInput').attr('value',dates[1]);
            start = dates[0];
            end = dates[1];

            $('#calendarContainer').datepicker( 'destroy' );
            setUpBooking();
            $('#calendarContainer').datepicker("setDate", start);
        })
        $('#bookingCta').click(function(){
            $('#bookingContainer').addClass('active')
        })
        $('#bookingClose').click(function(){
            $('#bookingContainer').removeClass('active')
        })

		

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		

		function setUpBooking() {
	

			$('#calendarContainer').datepicker({
				changeMonth: false,
				minDate:0,
				dateFormat: 'mm-dd-yy',
				numberOfMonths: 2,
				beforeShowDay: function (date) {
					setTimeout(function() {
						document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
							e.setAttribute('tabindex', '-1');
						})
					}, 1000);
					$.datepicker._defaults.dateFormat = "mm-dd-yy";
					
					var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
					var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
					if (date.getTime() == startDate.getTime()) {
						return [true, "startday"];
					} else {
						if (date.getTime() == endDate.getTime()) {
							return [true, "endday"];
						} else {
							if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
								return [true, "days"];
							} else {
								return [true, ""];
							}
						}
					}
				},
				onSelect: function (date) {
					var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
					var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
					var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);
					
					if (opened == 0) {
						opened = 1;
						start = date;
						end = date;

						//opencheck = 0;
					} else {
						opened = 0;
						if (selectedDate <= arrive) {
							end = start;
							start = date;
						} else {
							end = date;
						}

						
					} 
					$('#altDates').attr('value',start +'/'+end);
					
					var NewStart = start.split("-");
					NewStart.unshift(NewStart.pop());
					NewStart = NewStart.join('-')
					
					
					var NewEnd = end.split("-");
					NewEnd.unshift(NewEnd.pop());
					NewEnd = NewEnd.join('-')
					
					console.log(NewStart);
					console.log(NewEnd);
					$('#arriveInput').attr('value',NewStart);
					$('#departureInput').attr('value',NewEnd);
				
				
				}
			});
		}

	document.addEventListener('DOMContentLoaded', () => {
		
		let buttonToExpand = document.querySelectorAll(`.js_button_expand`)

		if( buttonToExpand ){
			let contentToExpand = null

			buttonToExpand.forEach( button => {
				contentToExpand = button.parentNode
				button.addEventListener( 'click', () => {
					contentToExpand.firstElementChild.classList.toggle('extended')
				} )
			})
		}

	});

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}